import React, { useState } from 'react'
import useDisplayTime from '../../../../hooks/useDisplayTime'
import NoteTooltip from './NoteTooltip';
import useOperatorStorage from '../../../../hooks/localStorage/useOperatorStorage';
import './MetaCell.css'

export default function MetaCell({kInfo={}}) {
  const {operator} = useOperatorStorage();  
  const {compressedTimestamp, significantTime} = useDisplayTime();
  const [mouseOver, setMouseOver] = useState();

  const modified = compressedTimestamp(kInfo.whenModified);
  const who = operator.username === kInfo.whoModified ? 'me' : kInfo.whoModified;

  //---[ Team Shared ]---

  const flagEditing   = kInfo.keyEdit || kInfo.valEdit || kInfo.titleEdit || kInfo.noteEdit ? '✎' : '';
  //const flagNotice    = kInfo.notice ? '♪' : '';
  
  //𝒩 

  //---[ Personal ]---
  
  // Whole Property
  // ✔  ✡
  const flagSuccess     = kInfo.success ? '✔' : ''; // ✡ ✔ ✔ ✓

  // ProgKey
  const flagKeyEdit     = kInfo.keyEdit ? 'k' : '';
  const flagKeyWarn     = kInfo.keyWarn ? '!' : '';
  const flagKeyError    = kInfo.keyErrorInfo ? '𝓚' : '';
  const flagKeySuccess  = kInfo.keySuccess ? '✓' : '';

  // Value
  const flagValEdit     = kInfo.valEdit ? 'v' : '';
  // const flagValWarn     = kInfo.valWarn ? '𝓦' : '';
  const flagValError    = kInfo.valErrorInfo ? '𝓥' : ''; // 🚩
  const flagValSuccess  = kInfo.valSuccess ? '✓V' : ''; // 🚩

  // Title

  // Note
  // const noteErrorMessage = kInfo.keyErrorInfo?.message || '';
  
  // Modified By
  const modifiedInfo = `${kInfo.whyModified} by ${who}, ${modified}`;  
  const sigTime = significantTime(kInfo.whenModified);

  return (
    <div className='metaCell'>
      <div className='metaCol metaFlags'>
        {flagEditing}
        {flagSuccess}
        {flagKeyEdit}
        {flagKeySuccess}
        {flagKeyWarn}
        {flagKeyError}
        {flagValEdit}
        {flagValError}
        {flagValSuccess}
      </div>
      <div className='metaCol metaModified' onMouseEnter={()=>setMouseOver(true)} onMouseLeave={()=>setMouseOver(false)}>
        {sigTime}
        {mouseOver && modifiedInfo && <NoteTooltip subject='' body={modifiedInfo} />}
      </div>
    </div>
  )
}
